// src/pages/WaitListSignUpPage.js
import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import HeaderBar from "../components/HeaderBar";
import { apiPost } from "../lib/apiClient";
import "../styles/LandingPage.css";

const BUSINESS_CATEGORIES = [
  "Restaurant & Cafe",
  "Coffee Shop",
  "Bakery",
  "Bar / Brewery / Taproom",
  "Food Truck",
  "Grocery / Market",
  "Fitness / Gym",
  "Yoga / Wellness Studio",
  "Salon & Spa",
  "Barber Shop",
  "Pet Services",
  "Auto Repair & Car Care",
  "Cleaning Services",
  "Home Improvement: General Contractor",
  "Home Improvement: Plumbing",
  "Home Improvement: Electrical",
  "Home Improvement: HVAC",
  "Home Improvement: Flooring & Painting",
  "Home Furnishings & Decor",
  "Landscaping & Gardening",
  "Retail Boutique / Gift Shop",
  "Bookstore / Stationery",
  "Kids Activities / Education",
  "Professional Services: Accounting & Bookkeeping",
  "Professional Services: Legal",
  "Professional Services: Marketing & Consulting",
  "Health Clinic / Urgent Care",
  "Pharmacy",
  "Entertainment & Events",
  "Coworking / Offices",
  "Tourism & Travel",
  "Other",
];

export default function WaitListSignUpPage() {
  const [wlRole, setWlRole] = useState("user");
  const [wlEmail, setWlEmail] = useState("");
  const [wlCategory, setWlCategory] = useState("");
  const [wlConsent, setWlConsent] = useState(false);
  const [wlMsg, setWlMsg] = useState("");
  const [wlSubmitting, setWlSubmitting] = useState(false);

  useEffect(() => {
    if (wlRole !== "business" && wlCategory) {
      setWlCategory("");
    }
  }, [wlRole, wlCategory]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setWlMsg("");

    if (!wlConsent) {
      setWlMsg(
        "Please check the consent box to receive email alerts before joining the waitlist."
      );
      return;
    }
    if (wlRole === "business" && !wlCategory) {
      setWlMsg("Please choose your business category.");
      return;
    }

    try {
      setWlSubmitting(true);
      const payload = {
        email: wlEmail,
        role: wlRole,
        category: wlRole === "business" ? (wlCategory || "").trim() : null,
        consent: wlConsent,
      };
      await apiPost("/waitlist", payload);
      setWlMsg("Thanks! You are on the waitlist.");
      setWlEmail("");
      setWlConsent(false);
      if (wlRole === "business") {
        setWlCategory("");
      }
    } catch (err) {
      const msg = err?.msg || err?.message || "Failed to join waitlist";
      setWlMsg(msg);
    } finally {
      setWlSubmitting(false);
    }
  };

  return (
    <div className="landing-page landing-page--simple">
      <HeaderBar />

      <main className="search-hero" role="main">
        <div className="card" style={{ maxWidth: 760, width: "100%" }}>
          <h2 style={{ marginTop: 0, marginBottom: 8 }}>
            Join the getSurvey Waitlist
          </h2>
          <p style={{ marginTop: 0, color: "#4b5563" }}>
            We’re actively researching and developing the getSurvey platform.
            The first 10 businesses in each category to join the waitlist will
            receive <strong>6 months of free access</strong> to all features when
            we launch. Individuals can also sign up to receive early access
            updates.
          </p>

          <form
            className="search-form"
            onSubmit={handleSubmit}
            aria-label="Waitlist signup"
          >
            <div
              style={{
                display: "flex",
                gap: 8,
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              <label
                htmlFor="wl-role"
                className="muted"
                style={{ minWidth: 80 }}
              >
                I am a
              </label>
              <select
                id="wl-role"
                value={wlRole}
                onChange={(e) => setWlRole(e.target.value)}
              >
                <option value="user">User</option>
                <option value="business">Business</option>
              </select>

              {wlRole === "business" && (
                <>
                  <label htmlFor="wl-category" className="muted">
                    Category
                  </label>
                  <select
                    id="wl-category"
                    value={wlCategory}
                    onChange={(e) => setWlCategory(e.target.value)}
                    style={{ flex: "1 1 220px" }}
                    required
                  >
                    <option value="" disabled>
                      Select a category
                    </option>
                    {BUSINESS_CATEGORIES.map((cat) => (
                      <option key={cat} value={cat}>
                        {cat}
                      </option>
                    ))}
                  </select>
                </>
              )}
            </div>

            <div
              style={{
                display: "flex",
                gap: 8,
                alignItems: "center",
                marginTop: 8,
              }}
            >
              <label htmlFor="wl-email" className="muted" style={{ minWidth: 80 }}>
                Email
              </label>
              <input
                id="wl-email"
                type="email"
                required
                placeholder="you@example.com"
                value={wlEmail}
                onChange={(e) => setWlEmail(e.target.value)}
                style={{ flex: "1 1 280px" }}
              />
            </div>

            <label
              style={{
                display: "flex",
                gap: 8,
                alignItems: "center",
                marginTop: 8,
              }}
            >
              <input
                type="checkbox"
                checked={wlConsent}
                onChange={(e) => setWlConsent(e.target.checked)}
              />
              I agree to receive email alerts when getSurvey is available or
              new features are released.
            </label>

            <div className="search-actions" style={{ gap: 8, marginTop: 10 }}>
              <button
                className="btn"
                type="submit"
                disabled={wlSubmitting}
                style={{
                  background: "#ffffff",
                  color: "#111827",
                  border: "1px solid #e5e7eb",
                  opacity: wlSubmitting ? 0.7 : 1,
                }}
              >
                {wlSubmitting ? "Joining…" : "Join the waitlist"}
              </button>
            </div>

            {wlMsg && (
              <div
                className="muted"
                role="status"
                style={{ marginTop: 8 }}
                aria-live="polite"
              >
                {wlMsg}
              </div>
            )}
          </form>
        </div>
      </main>

      <Footer />
    </div>
  );
}
